<template>
  <div v-if="showPage403" class="animated fadeIn content-holder"> 
    <Page403></Page403>
  </div>
  <div v-else class="animated fadeIn content-holder">
    <b-card no-body>
      <b-card-header class="custom-header">
        <div><i class="icon-note"></i> {{ formTitle }}</div>
        <b-button-group>       
          <b-button v-on:click="post()" :disabled="disabled"><i class="fa fa-save"></i> Save</b-button>
          <b-button v-on:click="post('andClose')" :disabled="disabled"><i class="fa fa-save"></i> Save & Close  </b-button>
          <b-button v-on:click="routerBack()"><i class="fa fa-times text-danger"></i> Cancel</b-button>
        </b-button-group>
      </b-card-header>

      <!-- Modal Component -->
      <div>
        <Modals ref="form"></Modals>
      </div>

      <b-card-body v-if="isLoading">
        <spinner></spinner> 
      </b-card-body>
      <b-card-body v-else>
        <b-row>
          <b-col md="12">
            <b-form v-on:submit.prevent="onSubmit" v-on:reset.prevent="onReset" novalidate>
                <b-tabs content-class="mt-3" align="left">
                  <b-tab title="Details" active>
                    <b-row>
                      <b-col md="4">
                        <b-form-group id="formName"
                          label="Name"
                          label-class="font-weight-bold pt-0 required"
                          label-for="formName">
                          <b-form-input id="formName"
                            type="text"
                            aria-describedby="formName"
                            v-model.lazy.trim="$v.form.formName.$model"
                            :state="chkState('formName')"
                            placeholder="Name" />
                          <b-form-invalid-feedback id="formName">
                            This is a required field and must be at least 5 character
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </b-col>
                      <b-col md="8">
                        <b-form-group id="formDescription"
                          label="Description"
                          label-class="font-weight-bold pt-0"
                          label-for="formDescription">
                          <b-form-input id="formDescription"
                            type="text"
                            v-model.lazy.trim="$v.form.formDescription.$model"
                            aria-describedby="formDescription"
                            placeholder="Description" />
                          <b-form-invalid-feedback id="formDescription">
                            This is a required field and must be at least 5 character
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col md="4">
                        <b-form-group id="formAction"
                          label="Successful Submit Action"
                          label-class="font-weight-bold pt-0 required"
                          label-for="formAction">
                          <v-select id="formAction" 
                            name="formAction"
                            :options="formActionOptions"
                            v-model="$v.form.formAction.$model" 
                            :class="{'select-invalid-border': form.formAction === null ? true : false}"
                            placeholder="Choose"
                          />
                          <small class="label-danger" v-if="form.formAction === null ? true : false">
                            This is a required field.
                          </small>
                        </b-form-group>
                      </b-col>
                      <b-col md="8" v-if="form.formAction !== 'Remain at form'">
                        <b-form-group id="formMessage"
                          label="Redirect URL/Message"
                          label-class="font-weight-bold pt-0 required"
                          label-for="formMessage">
                          <b-form-input id="formMessage"
                            type="text"
                            aria-describedby="formMessage"
                            v-model.lazy.trim="$v.form.formMessage.$model"
                            :state="chkState('formMessage')"
                            placeholder="Message" />
                          <b-form-invalid-feedback id="formMessage" v-if="form.formAction === 'Redirect URL'">
                            This is a required field and must be valid URL
                          </b-form-invalid-feedback>
                          <b-form-invalid-feedback id="formMessage" v-if="form.formAction === 'Display message'">
                            This is a required field and must be at least 5 character
                          </b-form-invalid-feedback>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col md="12">
                        <!-- Last Name -->
                        <b-form-group id="aliasInputGroup2"
                          label="Customized Style"
                          label-class="font-weight-bold pt-0"
                          label-for="description">
                            <div class="style-help"><b-button size="sm" v-b-popover.hover.top="styleHelp"  title="Customize Style Help"><i class="fa fa-question-circle"></i></b-button></div>
                            <b-form-textarea
                              placeholder="Enter Your CSS Style"
                              v-model.lazy.trim="$v.form.formStyle.$model"
                              rows="8">
                            </b-form-textarea>
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-tab>
                  <b-tab title="Fields">
                    <b-row>
                      <b-col md="12">
                        <div id="fb-template"></div>
                      </b-col>
                    </b-row>
                  </b-tab>
                  <b-tab title="Translation" class="font-size-12">
                    <b-row>
                      <b-col md="12">
                        <b-form-group id="translationGroup"
                          label="Translation"
                          label-class="font-weight-bold pt-0 font-size-14-override"
                          label-for="formTranslation">

                            <div class="style-help">
                              <b-button size="sm" id="translationHelp" v-b-modal.modal-translation-help>
                                <i class="fa fa-question-circle"></i>
                              </b-button>
                              <b-modal hide-footer id="modal-translation-help" title="Form Fields Translation JSON Object (Example)">
                                <pre v-if="exampleFormTransaltions" class="code-block">{{exampleFormTransaltions}}</pre>
                                <p>For translation of static HTML elements (inside Form/LandingPage), simply add attribute <b>data-lang="en"</b> <b>data-lang="ch"</b>.</p>
                              </b-modal>
                            </div>
                            <b-form-textarea
                              placeholder="Enter Your Translation In JSON Object Format. Click Help(?) to see example."
                              v-model.lazy.trim="formTranslation"
                              rows="15">
                            </b-form-textarea>
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-tab>
                  <b-tab title="Form Submission Actions" class="font-size-12" @click="fetchLatestFormInputfields()">
                    <div>
                      <b-form-group id="aliasInputGroup2"
                          label="Select an action from the 'Add a submit action' list."
                          label-class="font-weight-bold pt-0"
                          label-for="description">
                        <b-dropdown 
                          id="dropdown-1" 
                          variant="outline-primary" 
                          text="Add a submit action" 
                          class="m-md-2"
                        >
                          <b-dropdown-item @click="chooseSubmitAction('sendFormResult')">Send form results</b-dropdown-item>
                        </b-dropdown>
                      </b-form-group>
                    </div>
                    <b-card 
                      class="actionCard"
                      v-if="formSubmissionActions"
                      v-for="(action,index) in formSubmissionActions"
                      v-bind:key="index"
                    >
                      <template v-slot:header>
                        <b-row>
                          <b-col>
                            <h5>{{action.actionName}} ({{action.actionType}})</h5>
                          </b-col>
                          <b-col class="actionEditDelete">
                            <b-button size="sm" variant="secondary" @click="editAction(index, action)">
                              <i class="fa fa-edit"></i>
                            </b-button>
                            <b-button size="sm" variant="danger" @click="removeAction(index)">
                              <i class="fa fa-trash"></i>
                            </b-button>
                          </b-col>
                        </b-row>
                      </template>
                      <b-card-text v-if="action.to">
                        <b>Send To: </b>{{action.to}}
                      </b-card-text>
                    </b-card>
                  </b-tab>
                </b-tabs>
            </b-form>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>

    <!-- sendFormResult Action category-->
    <b-modal v-model="sendFormResultModalOpen"
      title="Send form results"
      size="lg"
      dialog-class="font-size-13"
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
    >
      <b-form-group label="Name" 
        label-for="sendFormResultActionName"
        label-class="font-weight-bold pt-0 required"
      >
        <b-form-input
          id="sendFormResultActionName"
          name="sendFormResultActionName"
          type="text"
          v-model.lazy.trim="sendFormResultObject.actionName"
          v-validate="{required:true, min:2}"
          :class="{'invalid-border': errors.first('sendFormResultActionName')}"
          placeholder="Name"
          autofocus
          autocomplete="off"
        />
        <b-form-invalid-feedback
          id="input1LiveFeedback1"
          v-if="errors.has('sendFormResultActionName')" style="display:block;"
        >
          A name is required & must be at least 2 characters.
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group label="Description" 
        label-for="sendFormResultActionDescription"
        label-class="font-weight-bold pt-0"
      >
        <b-form-textarea
          id="sendFormResultActionDescription"
          name="sendFormResultActionDescription"
          placeholder="Type something"
          v-model.lazy.trim="sendFormResultObject.actionDescription"
          autocomplete="off"
          no-resize
          rows="3">
        </b-form-textarea>
      </b-form-group>
      <b-row>
        <b-col>
          <b-form-group label="Subject" 
            label-for="sendFormResultActionSubject"
            label-class="font-weight-bold pt-0 required"
          >
            <template slot="label">
              Subject <i id="popover-target-subject" class="fa fa-question-circle" v-b-modal.modal-subject-help></i>
              <b-modal hide-footer id="modal-subject-help" title="Subject">
                <span v-html="`Value Fields available to embed in Subject: <b>{{formName}}</b>, <b>{{formCode}}</b>, <b>{{campaignName}}</b>`"></span>
              </b-modal>
            </template>
            <b-form-input
              id="sendFormResultActionSubject"
              name="sendFormResultActionSubject"
              type="text"
              v-model.lazy.trim="sendFormResultObject.subject"
              v-validate="{required:true, min:5}"
              :class="{'invalid-border': errors.first('sendFormResultActionSubject')}"
              placeholder=""
              autocomplete="off"
            />
            <b-form-invalid-feedback
              id="input1LiveFeedback1"
              v-if="errors.has('sendFormResultActionSubject')" style="display:block;"
            >
              This is required & must be at least 5 characters.
            </b-form-invalid-feedback>
          </b-form-group>
          
        </b-col>
        
      </b-row>
      <b-row>
        <b-col>
          <b-form-group label="Message" 
            label-for="sendFormResultActionMsg"
            label-class="font-weight-bold pt-0 required"
          >
            <template slot="label">
              Message 
              <i id="popover-target-msg" class="fa fa-question-circle" v-b-modal.modal-message-help></i>
              <b-modal hide-footer id="modal-message-help" title="Message">
                <span v-html="`Value Fields available to embed in Message: <b>{{formName}}</b>, 
                <b>{{formCode}}</b>, <b>{{campaignName}}</b>, <b>{{scan-city}}</b>, <b>{{scan-country}}</b>, <br/> 
                <b>{{campaign-qr-link}}</b> : Full QR link ,<br/> 
                <b>{{campaign-wrongly-typed-protectCode}}</b> : A wrongly typed protectCode value from previous protectCode-Form in the Campaign.`"></span>
              </b-modal>
            </template>
            <vue-editor 
              v-model="sendFormResultObject.message" 
              v-validate="{required:true, min:5}"
              data-vv-name="sendFormResultObjectMsg"
              id="sendFormResultObjectMsg"
              name="sendFormResultObjectMsg"
              ref="sendFormResultObjectMsg"
              :class="{'invalid-border': errors.first('sendFormResultObjectMsg')}"
            />
            <b-form-invalid-feedback
              id="input1LiveFeedback1"
              v-if="errors.has('sendFormResultObjectMsg')" style="display:block;"
            >
             This is required & must be at least 5 characters.
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col cols="3">
          <label class="font-weight-bold pt-0">Click to insert field 
            <i v-b-tooltip.hover title="Supported Fields: Text Field, Text Area, Number, Date Field, Select, Radio Group, Checkbox Group" class="fa fa-question-circle"></i>
          </label>
          <b-list-group v-if="availableFormInputFields" id="availableFormInputFields" class="available-formfields">
            <b-list-group-item
             button
             v-for="(field) in availableFormInputFields"
             v-bind:key="field.name"
             @click="addFieldToMessageEditor(field)"
            >
              {{field.label || field.field_label || field.placeholder || field.name}}
            </b-list-group-item>
          </b-list-group>
          <p v-if="availableFormInputFields && availableFormInputFields.length<=0" style="color: #007bff; padding-top: 20px;">Add fields in "Fields" tab to appear in here.</p>
        </b-col>
      </b-row>
      <b-form-group label="To" 
        label-for="sendFormResultActionTo"
        label-class="font-weight-bold pt-0 required"
      >
        <template slot="label">
         To <i v-b-tooltip.hover title="Separate multiple emails with a comma." class="fa fa-question-circle"></i>
        </template>  
        <b-form-input
          id="sendFormResultActionTo"
          name="sendFormResultActionTo"
          type="text"
          v-model.lazy.trim="sendFormResultObject.to"
          v-validate="{required:true, regex: multipleEmailCommaSeperatedRegex}"
          :class="{'invalid-border': errors.first('sendFormResultActionTo')}"
          autocomplete="off"
        />
        <b-form-invalid-feedback
          id="input1LiveFeedback1"
          v-if="errors.has('sendFormResultActionTo')" style="display:block;"
        >
          This is required and type the correct email format.
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group label="CC" 
        label-for="sendFormResultActionCC"
        label-class="font-weight-bold pt-0"
      >
        <template slot="label">
         CC <i v-b-tooltip.hover title="Separate multiple emails with a comma." class="fa fa-question-circle"></i>
        </template> 
        <b-form-input
          id="sendFormResultActionCC"
          name="sendFormResultActionCC"
          type="text"
          v-model.lazy.trim="sendFormResultObject.cc"
          v-validate="{regex: multipleEmailCommaSeperatedRegex_ForCcBcc}"
          :class="{'invalid-border': errors.first('sendFormResultActionCC')}"
          placeholder="Optional"
          autocomplete="off"
        />
        <b-form-invalid-feedback
          id="input1LiveFeedback1"
          v-if="errors.has('sendFormResultActionCC')" style="display:block;"
        >
          Type the correct email format.
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group label="BCC" 
        label-for="sendFormResultActionBCC"
        label-class="font-weight-bold pt-0"
      >
        <template slot="label">
         BCC <i v-b-tooltip.hover title="Separate multiple emails with a comma." class="fa fa-question-circle"></i>
        </template> 
        <b-form-input
          id="sendFormResultActionBCC"
          name="sendFormResultActionBCC"
          type="text"
          v-model.lazy.trim="sendFormResultObject.bcc"
          v-validate="{regex: multipleEmailCommaSeperatedRegex_ForCcBcc}"
          :class="{'invalid-border': errors.first('sendFormResultActionBCC')}"
          placeholder="Optional"
          autocomplete="off"
        />
        <b-form-invalid-feedback
          id="input1LiveFeedback1"
          v-if="errors.has('sendFormResultActionBCC')" style="display:block;"
        >
          Type the correct email format.
        </b-form-invalid-feedback>
      </b-form-group>
      
      <template v-slot:modal-footer>
        <b-button size="md" @click="cancelSendFormResultAddAction()">
          Cancel
        </b-button>
        <b-button size="md" variant="primary" @click="addSendFormResultAction()">
          {{sendFormResultObjectEditIndex!==null ? 'Update' : 'Add'}}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>

import Vue from 'vue';
import uuid from "uuid";
import vSelect from 'vue-select';
import { router } from '../../router/index';
import VueNotifications from 'vue-notifications';
import { validationMixin } from "vuelidate";
import { VueEditor, Quill } from "vue2-editor";
import miniToastr from 'mini-toastr';
import { apigClient } from '@/shared/api';
import { formBuilder } from "formBuilder";
import { required, minLength, helpers } from "vuelidate/lib/validators";
import { imageHolder } from "./img.js";
import { controlLinkHolder } from "./hreflink.js";
import { controlMetaHolder } from "./meta.js";
import { controlYesNoGroupHolder } from "./custom-controls/yesnogroup.js";
import { controlRedirectInXSec } from "./custom-controls/redirectInXSec.js";
import { exampleFormTransaltions } from "./custom-controls/example_formTranslations";
import Modals from "@/shared/Modals.vue";
import Page403 from "@/views/pages/Page403.vue";

const Spinner = () => import('../shared/Spinner');

const toastTypes = {
  success: 'success',
  error: 'error',
  info: 'info',
  warn: 'warn'
}

miniToastr.init({types: toastTypes})

function toast ({title, message, type, timeout, cb}) {
  return miniToastr[type](message, title, timeout, cb)
}

const options = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast
}

const formShape = {
  formName: '',
  formDescription: '',
  formAction: 'Remain at form',
  formMessage: '',
  formStyle: ''
}

Vue.use(VueNotifications, options);
export default {
  name: 'FormBuilder',
  components: {
    formBuilder,
    Spinner,
    vSelect,
    Modals,
    Page403,
    VueEditor,
    Quill
  },
  data() {
    let newModePage = true;
    if(window.location.href.includes("/edit")){
      newModePage = false;
    }
    return {
      loginUserInfo: JSON.parse(localStorage.getItem('loginUserInfo')),
      permission: {
        permissionBaseName: null,
        permissionBaseNameCapabilities: null,
        capabilities: {
          View: false,
          Edit: false,
          Delete: false,
          Create: false,
        }
      },
      showPage403: false,
      newModePage: newModePage,
      disabled: true,
      isLoading: false,
      isEdit: false,
      isSubmitted: false,
      fbBuilder: {},
      companyId: '',
      form: Object.assign({}, formShape),
      formTranslation: null,
      formSubmissionActions: [],
      sendFormResultObject: {
        actionName: null,
        actionType: 'sendFormResult',
        actionDescription: null,
        subject: null,
        message: "",
        to: null,
        cc: null,
        bcc: null,
      },
      subjectTemplate: "CampaignProductContactFormResult: [your Written Subject]",
      availableFormInputFields: null,
      multipleEmailCommaSeperatedRegex: /^(\s?[^\s,]+@[^\s,]+\.[^\s,]+\s?,)*(\s?[^\s,]+@[^\s,]+\.[^\s,]+)$/,
      multipleEmailCommaSeperatedRegex_ForCcBcc: /^(\s?[^\s,]+@[^\s,]+\.[^\s,]+\s?,)*(\s?[^\s,]+@[^\s,]+\.[^\s,]+|N\/A)$/,
      sendFormResultModalOpen: false,
      sendFormResultObjectEditIndex: null,
      editingAction: null,
      formId: null,
      mediaOptions: {},
      exampleFormTransaltions: exampleFormTransaltions,
      formActionOptions: [
        'Remain at form',
        'Redirect URL',
        'Display message'
      ],
      formType: 'form',
      formTitle: '',
      defaultFormData: [],
      defaultFormOnLoad: [{
        'type': 'button',
        'label': 'Submit',
        'subtype': 'submit',
        'className': '',
        'name': 'button-default'
      }],
      defaultCodeFormOnLoad: [
        {
          'type': 'Image',
          'label': 'image',
        },
        {
          'type': 'paragraph',
          'label': 'Please type the code as it is shown on label above',
        },
        {
          'className': 'form-control',
          'label': 'Protect Code',
          'name': 'text-protect-code',
          'required': true,
          'subtype': 'text',
          'type': 'text'
        },
        {
          'type': 'button',
          'label': 'Submit',
          'subtype': 'submit',
          'className': '',
          'name': 'button-default'
        }
      ],
      defaultImageFormOnLoad: [
        {
          'type': 'Image',
          'label': 'image',
        },
        {
          'type': 'yesnogroup',
          'label': 'Does your Item Look Like the Above?',
        },
      ],
      styleHelp: 'body {/* this is body style */} \n \n .main {/* this class name is to be changed body */} \n \n .form {/* this class name is to be changed the whole form content */} \n \n .form-message {/* this class name is to be changed successfully message after form submitting */} \n \n .form-content {/* this class name is to be changed all form inputs */}'
    }
  },
  validations() {
    if (this.form.formAction === 'Remain at form') {
      return {
        form: {
          formName:{
            required,
            minLength: minLength(5)
          },
          formDescription:{
          },
          formAction: {
            required
          },
          formMessage: {
          },
          formStyle: {
          },
        }
      }
    } else if (this.form.formAction === 'Redirect URL') {
      return {
        form: {
          formName:{
            required,
            minLength: minLength(5)
          },
          formDescription:{
          },
          formAction: {
            required
          },
          formMessage: {
            required,
            alpha: helpers.regex('alpha', /(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9]/)
          },
          formStyle: {
          },
        }
      }
    } else if (this.form.formAction === 'Display message') {
      return {
        form: {
          formName:{
            required,
            minLength: minLength(5)
          },
          formDescription:{
          },
          formAction: {
            required
          },
          formMessage: {
            required,
            minLength: minLength(5)
          },
          formStyle: {
          },
        }
      }
    }
  },
  created: function() {
  },
  watch: {
    'form.formAction': function(val){
      if (val !== 'Remain at form') {
        this.chkState('formMessage');
      }
    },
    $route (to, from){
      this.checkRoute(to.name);
      this.isLoading = true;
      this.loadCustomForms();
    }
  },
  mounted: function(){
    this.getPermission();
    if(this.newModePage && !this.permission.capabilities.Create){
      this.showPage403 = true;
      return;
    } else if ( !this.newModePage && !this.permission.capabilities.Edit){
      this.showPage403 = true;
      return;
    }
    
    const user = JSON.parse(localStorage.getItem('loginUserInfo'));
    this.companyId = (user.db.company.id == null || user.db.company.id == undefined || user.db.company.id == 'NULL') ? '' : user.db.company.id;
    this.checkRoute(this.$route.name);
    if (this.$route.params.id) {
      this.getData(this.$route.params.id);
      this.isEdit = true;
      this.formId = this.$route.params.id;
    } else {
      this.buildFormbuilder();
    }
  },
  computed: {
    formStr() { return JSON.stringify(this.form, null, 4) },
    isValid() { return !this.$v.form.$anyError },
    isDirty() { return this.$v.form.$anyDirty },
  },
  mixins: [validationMixin],
  methods: {
    fetchLatestFormInputfields(){
      const currentFormFields = this.fbBuilder.actions.getData();
      if(currentFormFields){
        let availableFieldTypes = ['text', 'number', 'date', 'radio-group', 'checkbox-group', 'select', 'textarea'];
        this.availableFormInputFields = currentFormFields.filter(f => availableFieldTypes.includes(f.type));
      }
    },
    addFieldToMessageEditor(field){
      if(field.name){
        const msgEditorQuill = this.$refs.sendFormResultObjectMsg.quill;
        const editorSelection = msgEditorQuill.getSelection();
        
        const msgEditorCurrentCursorIndex = editorSelection ? editorSelection.index : null;
        const fieldLabel = field.label || field.field_label || field.placeholder || field.name;
        msgEditorQuill.insertText((msgEditorCurrentCursorIndex || msgEditorQuill.getLength() - 1), `${fieldLabel} : {{${field.name}}}`, 'bold', true);
      }
    },
    getPermission(){
      let that = this;
      const userPermissionsBasedOnEntity = that.loginUserInfo.db.userPermissionsBasedOnEntity;
      if(this.$route.meta && userPermissionsBasedOnEntity){
        that.permission.permissionBaseName = this.$route.meta.permissionBaseName;
        let userPermissionBasedOnEntity = userPermissionsBasedOnEntity.find(p => p.permissionBaseName === this.$route.meta.permissionBaseName);
        if(userPermissionBasedOnEntity){
          that.permission.permissionBaseNameCapabilities = userPermissionBasedOnEntity.capabilities;
          that.permission.permissionBaseNameCapabilities.forEach(capability=>{
            that.permission.capabilities[capability.label] = capability.value
          });
        } 
      } else{
        router.push('/no-permission-given');
      }
      console.log('permission: ' , that.permission);
    },
    checkRoute: function(routePath) {
      if (routePath.indexOf('formBuilder') > -1) {
        this.formType = 'Form';
        this.formTitle = this.$route.params.id ? 'Form Builder Edit' : 'Form Builder New';
        this.formRoute = '/components/form-builder/new';
        this.defaultFormData = this.$route.params.id ? [] : this.defaultFormOnLoad;
      } else if (routePath.indexOf('codeBuilder') > -1) {
        this.formType = 'Code';
        this.formTitle = this.$route.params.id ? 'Code Form Builder Edit' : 'Code Form Builder New';
        this.formRoute = '/components/code-builder/new';
        this.defaultFormData = this.$route.params.id ? [] : this.defaultCodeFormOnLoad;
      } else if (routePath.indexOf('imageBuilder') > -1) {
        this.formType = 'Image';
        this.formTitle = this.$route.params.id ? 'Image Form Builder Edit' : 'Image Form Builder New';
        this.formRoute = '/components/image-builder/new';
        this.defaultFormData = this.$route.params.id ? [] : this.defaultImageFormOnLoad;
      }
    },
    getData(id){
      var method = 'GET';
      var pathTemplate = '/formBuilder/' + id;
      var additionalParams ={};
      var pathParams = {};
      var that = this;
      that.isLoading = true;
      that.isSubmitted = true;
      apigClient.invokeApi(pathParams, pathTemplate, method, additionalParams)
        .then(function(result) {
          let response = result.data;
          console.log(result.data);
          if (response.status) {
            that.form.formName = response.data.formName;
            that.form.formDescription = response.data.formDescription === 'NULL' ? '' : response.data.formDescription;
            that.form.formAction = response.data.formAction === 'NULL' ? '' : response.data.formAction;
            that.form.formStyle = response.data.formStyle === 'NULL' ? '' : response.data.formStyle;
            that.form.formMessage = response.data.formMessage === 'NULL' ? '' : response.data.formMessage;
            that.formTranslation = response.data.formTranslation === 'NULL' ? '' : response.data.formTranslation;
            that.formSubmissionActions = (!response.data.formSubmissionActions || response.data.formSubmissionActions === 'NULL') ? [] : response.data.formSubmissionActions;
            that.isLoading = false;
            that.isSubmitted = false;
            that.buildFormbuilder(response.data.formContent);
          } else {
            that.showErrorMsg({message: response.message});
            that.isLoading = false;
            that.isSubmitted = false;
          }
        }).catch( function(error){
          that.showErrorMsg({message: error.message});
          that.isLoading = false;
          that.isSubmitted = false;
        });
    },
    addSendFormResultAction(){
      this.$validator.validateAll().then((validationOk) => {
        if(validationOk){
          this.sendFormResultObject.actionDescription = !this.sendFormResultObject.actionDescription ? 'N/A' : this.sendFormResultObject.actionDescription;
          this.sendFormResultObject.cc = !this.sendFormResultObject.cc ? 'N/A' : this.sendFormResultObject.cc;
          this.sendFormResultObject.bcc = !this.sendFormResultObject.bcc ? 'N/A' : this.sendFormResultObject.bcc;
          if(this.sendFormResultObjectEditIndex!==null){
            this.formSubmissionActions[this.sendFormResultObjectEditIndex] = this.sendFormResultObject;
          }else{
            this.formSubmissionActions.push(this.sendFormResultObject);
          }
          
          this.resetSendFormResultObject();
          this.sendFormResultModalOpen = false;
        }
      });
    },
    chooseSubmitAction(submitAction){
      if(submitAction==='sendFormResult'){
        this.resetSendFormResultObject();
        this.sendFormResultModalOpen = true;
      }
    },
    editAction(index, action){
      if(action.actionType === 'sendFormResult'){
        this.editingAction = {...action};
        this.sendFormResultObject = action;
        this.sendFormResultObjectEditIndex = index;
        
        this.sendFormResultModalOpen = true;
      }
    },
    removeAction(actionIndex){
      Vue.delete(this.formSubmissionActions, actionIndex);
    },
    cancelSendFormResultAddAction(){
      if(this.sendFormResultObjectEditIndex!==null){
        this.formSubmissionActions[this.sendFormResultObjectEditIndex] = this.editingAction;
      }
      this.resetSendFormResultObject();
      this.sendFormResultModalOpen = false;
    },
    resetSendFormResultObject(){
      this.sendFormResultObjectEditIndex = null;
      this.editingAction = null;
      this.sendFormResultObject = {
        actionName: null,
        actionType: 'sendFormResult',
        actionDescription: null,
        subject: null,
        message: null,
        to: null,
        cc: null,
        bcc: null,
      };
    },
    routerBack(){
      this.$router.go(-1);
    },
    post(option){
      var body = {
        formName: this.form.formName,
        formDescription: this.form.formDescription,
        formAction: this.form.formAction || 'Remain at form', // pervent 'null'
        formMessage: this.form.formMessage,
        formContent: this.fbBuilder.actions.getData(),
        formStyle: this.form.formStyle,
        formType: this.formType,
        formTranslation: this.formTranslation,
        formSubmissionActions: this.formSubmissionActions,
        companyId: this.companyId
      }
      if (this.formId) {
        body.updatedBy = this.loginUserInfo ? this.loginUserInfo.login_username : '';
      } else {
        body.createdBy = this.loginUserInfo ? this.loginUserInfo.login_username : '';
      }
      let method = this.formId ? 'PUT' : 'POST';
      let pathTemplate = this.formId ? `/formBuilder/${this.formId}` : '/formBuilder';
      let additionalParams ={};
      let pathParams = {};
      let that = this;
      that.isSubmitted = true;
      this.$refs.form.openModal();
        that.changeModalContent(
          "loading",
          "Updating...",
          "Updating Form Info"
      );
      apigClient.invokeApi(pathParams, pathTemplate, method, additionalParams, body)
        .then(function(result){
          if (result.data.status) {
            // if (that.formId) {
              if (option == "andClose") {
                that.changeModalContent(
                  "success",
                  "Saved success!",
                  "The Form data has been created"
                );
                setTimeout(() => {
                  that.routerBack();
                }, 2000);
              } else {
                // Apply
                that.changeModalContent(
                  "success",
                  "Saved success!",
                  "The Form data has been created"
                );
                setTimeout(() => {
                  that.$refs.form.closeModal();
                }, 2000);
              }
              // Error
            } else {
              that.changeModalContent(
                "error",
                "Error Occured!",
                "Error From API Endpoint: " + result.data.message
              );
            }
          })
          .catch(function(result) {
            that.changeModalContent(
              "error",
              "Error Occured!",
              "invokeAPI Error: " + result.message
            );
          });
    },
    async buildFormbuilder(configFields){
      let options = {
        disableHTMLLabels: true,
        disabledActionButtons: ['clear', 'save', 'data'],
        disableFields: ['file', 'hidden', 'autocomplete'],
        disabledFieldButtons:{
         // yesnogroup: ['remove']
        },
        disabledAttrs: [
          'access',
          'toggle',
          'description',
          'rows',
          'style',
          'name'
        ],
        typeUserAttrs: {
          text:{
            field_label:{
              label: 'Field Label',
              type: 'text',
              value: '',
            }
          },
          button:{
            field_label:{
              label: 'Field Label',
              type: 'text',
              value: '',
            }
          },
          'checkbox-group':{
            field_label:{
              label: 'Field Label',
              type: 'text',
              value: '',
            }
          },
          date:{
            field_label:{
              label: 'Field Label',
              type: 'text',
              value: '',
            }
          },
          header:{
            field_label:{
              label: 'Field Label',
              type: 'text',
              value: '',
            }
          },
          number:{
            field_label:{
              label: 'Field Label',
              type: 'text',
              value: '',
            }
          },
          paragraph:{
            field_label:{
              label: 'Field Label',
              type: 'text',
              value: '',
            }
          },
          'radio-group':{
            field_label:{
              label: 'Field Label',
              type: 'text',
              value: '',
            }
          },
          select:{
            field_label:{
              label: 'Field Label',
              type: 'text',
              value: '',
            }
          },
          textarea:{
            field_label:{
              label: 'Field Label',
              type: 'text',
              value: '',
            }
          },
          URL:{
            field_label:{
              label: 'Field Label',
              type: 'text',
              value: '',
            }
          },
          Image: {
            shape: {
              label: 'Media Library',
              options: this.mediaOptions,
            },
            field_label:{
              label: 'Field Label',
              type: 'text',
              value: '',
            }
          },
          yesnogroup: {
            field_label:{
              label: 'Field Label',
              type: 'text',
              value: '',
            },
            showLabel: {
              label: 'Show Label',
              type: 'checkbox',
              value: true
            },
            yesLabel:{
              label: 'Yes',
              value: '',
              placeholder: 'Default: Yes'
            },
            noLabel:{
              label: 'No',
              value: '',
              placeholder: 'Default: No'
            },
            fieldContainerAttributes:{
              label: 'Field container attributes',
              value: '',
            }
          },
          redirectInXSec: {
            field_label:{
              label: 'Field Label',
              type: 'text',
              value: '',
            },
            showMessage: {
              label: 'Show Message',
              type: 'checkbox',
              value: true
            },
            prefixMessage:{
              label: 'Prefix Message',
              value: '',
              placeholder: 'Default: You will be redirected to next page in '
            },
            suffixMessage:{
              label: 'Suffix Message',
              value: '',
              placeholder: 'Default: seconds'
            },
            redirectInSeconds:{
              label: 'Seconds',
              value: 3,
              type: 'number',
            },
            fieldContainerAttributes:{
              label: 'Field Container attributes',
              value: '',
            }
          },
        },
        typeUserDisabledAttrs: {
          'yesnogroup': [
            'placeholder',
            'required',
            'value',
          ],
          'redirectInXSec' : [
            'placeholder',
            'required',
            'value',
          ]
        },
        formData: this.formId ? [] : this.defaultFormData,
        dataType: 'json',
        layoutTemplates: {}
      };
      let result = await this.loadCustomFields();
      this.mediaOptions[''] = '';
      result[0].map(img => {
        this.mediaOptions[img.filepath] = img.title;
      });
      options.inputSets = result[1];
      options.defaultFields = configFields ? configFields : [];
      let fbEditor = document.getElementById('fb-template');
      this.fbBuilder = $(fbEditor).formBuilder(options);
    },
    changeModalContent(status = null, title = null, message = null) {
      let that = this;
      that.$refs.form.status = status ? status : that.$refs.form.status;
      that.$refs.form.title = title ? title : that.$refs.form.title;
      that.$refs.form.message = message ? message : that.$refs.form.message;
    },
    chkState(val) {
      const field = this.$v.form[val];
      this.disabled = field.$model !== undefined && (
        this.$v.form['formName'].$invalid || 
        this.$v.form['formAction'].$invalid || 
        this.$v.form['formMessage'].$invalid
      );
      return (field.$model !== '' && field.$model !== undefined) ? !field.$dirty || !field.$invalid : null;
    },
    loadCustomFields: function() {
      var method = 'GET';
      var pathTemplate = '/customFields/builder/' + this.companyId;
      var additionalParams ={};
      var pathParams = {};
      var that = this;
      that.isLoading = true;
      return apigClient.invokeApi(pathParams, pathTemplate, method, additionalParams)
        .then(function(result) {
          let response = result.data;
          if (response.status) {    
            that.isLoading = false;
            return response.data;
          } else {
            that.showErrorMsg({message: response.message});
            that.isLoading = false;
            return {error: response.message};
          }
        }).catch( function(error){
          that.showErrorMsg({message: error.message});
          that.isLoading = false;
          return {error: error.message};
        });
    },
  },
  notifications: {
    showSuccessMsgCreate: {
      type: VueNotifications.types.success,
      title: 'Operation successfull!',
      message: 'The object has been created'
    },
    showSuccessMsgUpdate: {
      type: VueNotifications.types.success,
      title: 'Operation successfull!',
      message: 'The object has been update'
    },
    showErrorMsg: {
      type: VueNotifications.types.error,
      title: null,
      message: ''
    },
  },
}
</script>

<style scoped>
  .btn.disabled {
    cursor: auto;
  }
  .custom-header{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 20px 10px 10px;
  }

  .btn-group > .btn, .btn-group-vertical > .btn {
      border: 1px solid #a4acb5;
  }

  @media only screen and (max-width: 600px) {
    .custom-header{
      flex-direction: column;
      align-items: inherit;
      padding: 10px 20px 10px 10px;
    }

    .custom-header > div:first-child {
      margin-bottom: 10px;
    } 

  }
  .custom-cancel {
    border-radius: 0.25rem 0 0 0.25rem;
  }
  .sk-fading-circle .sk-circle {
    margin: 0 auto;
  }
  .sk-three-bounce {
    height: 40px;
  }

  #fb-template {
    background: transparent;
  }

</style>

<style>

  .form-wrap.form-builder .frmb-control li::before {
    font-family: "formbuilder-icons", fb-icons;
  }

  .form-wrap.form-builder [class^=icon-]:before, .form-wrap.form-builder [class*=" icon-"]:before {
    font-family: "formbuilder-icons", fb-icons;
  }

  .nav [class^=nav-icon]:before, .nav [class*=" nav-icon"]:before {
    font-family: "simple-line-icons";
  }

  .navbar [class^=icon-]:before, .navbar [class*=" icon-"]:before {
    font-family: "simple-line-icons";
  }

  .custom-header [class^=icon-]:before, .navbar [class*=" icon-"]:before {
    font-family: "simple-line-icons";
  }

  .nav-icon [class^=nav-icon]:before, .nav [class*=" nav-icon"]:before {
    font-family: "simple-line-icons";
  }

  .btn.icon-pencil::before {
    font-family: "formbuilder-icons", fb-icons;
    content: '\e809';
  }

  .select-invalid-border .dropdown-toggle{
    border-color:#f86c6b;
  }

  .label-danger {
    color: #f86c6b;
  }

  .style-help {
    text-align: right;
    margin-bottom: 10px;
    font-size: 11px;
    font-weight: bold;
    color: #f86c6b;
    width: 100px;
    top: -1px;
    right: 15px;
    position: absolute;
  }
  #sendFormResultObjectMsg .ql-editor{
    font-size: 13px !important;
  }
</style>
<style scoped lang="less">
  .font-size-12{
    font-size: 12px !important;
  }
  .actionEditDelete{
    text-align: right;
    button{
      margin-left: 5px;
    }
  }
  .actionCard{
    .card-header{
      background-color:#ffffff;
      border:none;
    }
    .card-body{
      padding: 0px 0px 10px 20px;
    }
  }
  .available-formfields{
    overflow: auto;
    max-height: 284px;
    border: 0.5px solid rgba(0, 0, 0, 0.2);
    border-radius: 0.3rem;
  }
</style>
